const apiConfiguration = {
  // devBaseUrl: `http://68.183.227.47:5050/api`,
  // devBaseUrl: `http://localhost:5050/api`,
  devBaseUrl: `https://feedbacknow.services/api`
};

export { apiConfiguration };